import React, {Component} from 'react';
import anime from 'animejs';
import {observer} from 'mobx-react';
import {AppStore} from 'js/stores';
import styles from 'css/components/scroll-top.css';

@observer
/**
 * Scroll top
 */
export default class ScrollTop extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
    this.scrollUp = this.scrollUp.bind(this);
    this.onOff = this.onOff.bind(this);

    window.addEventListener('scroll', this.onOff);
  }

  /**
   * button on off
   */
  onOff() {
    if (20 > window.scrollY) {
      AppStore.scrollTopButtonView(false);
    } else {
      AppStore.scrollTopButtonView(true);
    }
  }

  /**
   * click
   */
  scrollUp() {
    anime({
      targets: 'html, body',
      scrollTop: 0,
      duration: 500,
      easing: 'easeInOutCubic',
    });
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <a
        ref="button"
        data-view={AppStore.scrollTopButton}
        className={styles.button}
        onClick={this.scrollUp}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/scroll-top/index.js